export default __webpack_public_path__ + "static/media/Logo-Zaivu-White.32eb1743.svg";